import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { IFilterResult } from 'APIPackage/MainModule/interfaces/IFilterResult';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';
import { apiDelete, apiGet, apiPost, apiPut } from 'APIPackage/MainModule/common/apiTools';

import { IPmListFilterRaw } from '../interfaces/IPmListFilterRaw';
import { IPmListFilterParams } from '../interfaces/IPmListFilterParams';

export async function fetchPmFilters(): Promise<IFilterResult[]> {
  return apiGet<IFilterResult[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/pm`);
}

export async function fetchPmFilterById(id: number): Promise<IPmListFilterRaw> {
  return apiGet<IPmListFilterRaw>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/pm/${id}`);
}

export async function createPmFilter(data: IPmListFilterRaw): Promise<IFilterResult> {
  const knmFilter = { ...data };

  return apiPost<IFilterResult>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/pm`,
    body: knmFilter,
  });
}

export async function updatePmFilter(id: number, data: IPmListFilterRaw): Promise<void> {
  return apiPut(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/pm/${id}`, data);
}

export async function deletePmFilter(id: number): Promise<void> {
  return apiDelete(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/filters/${id}`);
}

export async function exportPmList(
  format: ExportFormatsEnum,
  filter: IPmListFilterParams | null,
  columns: ITableColumn<IKnmRaw>[],
): Promise<IExport> {
  const params = new URLSearchParams();

  params.set('format', format);

  return apiPost<IExport>({
    url: `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/knm/export/pm?${params}`,
    body: {
      ...filter,
      /**
       * Соответствует правилу отображения таблицы (Table.tsx): колонка выбрана,
       * если только isSelected !== false. Простая проверка на истинность отбросит
       * стандартные колонки (isSelected === undefined) при первой загрузке
       * и отправит пустой массив requiredColumns.
       */
      requiredColumns: columns.filter(col => col.isSelected !== false).map(col => col.id),
    },
  });
}
